import React, { Dispatch } from "react";
import { ActionType } from "./types";
import { GetTenantDto } from "../../services/Tenant/dto/get.dto";
import { UpdateStatusParams } from "./usecase.d";
import { GetSuperModeratorDto } from "../../services/SuperModerator/dto/get.dto";

interface PatchIntroVideoValueParams {
  tenantIntroVideoUrl: string;
}

export type TenantStateType = {
  detail?: GetTenantDto;
  data?: Array<GetTenantDto>;
};

export type TenantActionType = {
  type: symbol;
  detailItem?: GetTenantDto;
  items?: GetTenantDto[];
  addedItem?: GetTenantDto;
  updatedItem?: GetTenantDto;
  deleteId?: string;
  updatedStatusItem?: UpdateStatusParams;
  createdSuperModeratorItem?: GetSuperModeratorDto;
  updatedSuperModeratorItem?: GetSuperModeratorDto;
  patchIntroVideo?: PatchIntroVideoValueParams;
};

type TenantReducerType = React.Reducer<TenantStateType, TenantActionType>;

export type TenantDispatch = Dispatch<TenantActionType>;

const initialGetState: TenantStateType = {
  data: new Array<GetTenantDto>(),
};

interface TransformUpdateDataParams {
  originalData: Array<GetTenantDto>;
  updatedData: GetTenantDto;
}

function transformUpdateData({
  originalData,
  updatedData,
}: TransformUpdateDataParams) {
  return originalData.map((item) => {
    if (item.id === updatedData.id) {
      return updatedData;
    }
    return item;
  });
}

interface TransformUpdateStatusDataParams {
  originalData: Array<GetTenantDto>;
  updatedStatusItem: UpdateStatusParams;
}

function transformUpdateStatusData({
  originalData,
  updatedStatusItem,
}: TransformUpdateStatusDataParams) {
  return originalData.map((item) => {
    const newItem = { ...item };
    if (item.id === updatedStatusItem.id) {
      newItem.isActive = updatedStatusItem.isActive;
    }
    return newItem;
  });
}

export const Reducer: TenantReducerType = (state = initialGetState, action) => {
  switch (action.type) {
    case ActionType.GetDetail:
      return {
        ...state,
        detail: action.detailItem,
      };
    case ActionType.GetList:
      return {
        ...state,
        data: action.items || [],
      };
    case ActionType.Create:
      if (!action.addedItem) {
        throw new Error("Added item does not exists");
      }
      return {
        ...state,
        data: [...(state.data || []), action.addedItem],
      };
    case ActionType.Update:
      if (!action.updatedItem) {
        throw new Error("Updated item does not exists");
      }
      return {
        ...state,
        detail: {
          ...state.detail,
          ...action.updatedItem,
        },
        data: transformUpdateData({
          originalData: state.data || [],
          updatedData: action.updatedItem,
        }),
      };
    case ActionType.UpdateStatus:
      if (!action.updatedStatusItem) {
        throw new Error("Updated item does not exists");
      }
      return {
        ...state,
        data: transformUpdateStatusData({
          originalData: state.data || [],
          updatedStatusItem: action.updatedStatusItem,
        }),
      };
    case ActionType.CreateSuperModerator:
      if (!action.createdSuperModeratorItem) {
        throw new Error("Created super moderator item does not exists");
      }
      return {
        ...state,
        detail: {
          ...state.detail,
          userFirstName: action.createdSuperModeratorItem.userFirstName,
          userLastName: action.createdSuperModeratorItem.userLastName,
          userEmail: action.createdSuperModeratorItem.userEmail,
          userStatus: action.createdSuperModeratorItem.userStatus,
          userId: action.createdSuperModeratorItem.id,
        } as GetTenantDto,
      };
    case ActionType.UpdateSuperModerator:
      if (!action.updatedSuperModeratorItem) {
        throw new Error("Updated super moderator item does not exists");
      }
      return {
        ...state,
        detail: {
          ...state.detail,
          userFirstName: action.updatedSuperModeratorItem.userFirstName,
          userLastName: action.updatedSuperModeratorItem.userLastName,
        } as GetTenantDto,
      };
    case ActionType.DeleteLogo:
      return {
        ...state,
      };
    case ActionType.PatchIntroVideo:
      if (!action.patchIntroVideo) {
        throw new Error("Patch intro video does not exists");
      }
      return {
        ...state,
        detail: {
          ...state.detail,
          tenantIntroVideoUrl: action.patchIntroVideo.tenantIntroVideoUrl,
        } as GetTenantDto,
      };
    default:
      return state;
  }
};
